import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import { useState } from "react"
import UploadFile from "../../UploadFile"
import axiosClient from "../../../lib/axios"
import { enqueueSnackbar } from "notistack"
import { useMutation, useQueryClient } from "react-query"
import { IAddArquivosProcessoInput } from "../../../types/mutations/adicionar-arquivos-processo"

export default function DialogEnviarArquivosProcesso({
    open,
    handleClose,
    codigo
}: DialogEnviarArquivosProcessoProps) {

    const queryClient = useQueryClient();

    const [files, setFiles] = useState<File[]>([])

    const haveNoFiles = files.length <= 0

    //queries e mutations
    const { mutate: enviarArquivosProcessos, isLoading } = useMutation({
        mutationKey: 'dialog-adicionar-arquivos-processo/',
        mutationFn: (inputs: IAddArquivosProcessoInput) => axiosClient.post("/adicionar-arquivos-processo/" + codigo, inputs, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }),
        onSuccess: ({ data }) => {
            enqueueSnackbar(`Arquivos enviados com sucesso!`, { variant: 'success' });
            queryClient.invalidateQueries("detalhar-processo")
            handleClose();
        }
    })
    //

    //funções manipuladoras
    const handleConfirm = async () => {
        let formData = new FormData();

        files.forEach((file, index) => {
            formData.append(`arquivos[${index}]`, file);
        });

        let params: IAddArquivosProcessoInput = {
            arquivos: []
        }

        files.forEach(file => {
            params.arquivos.push(file);
        });

        await enviarArquivosProcessos(params)
    }
    //

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
        >
            <DialogTitle>
                Enviar arquivos do processo
            </DialogTitle>

            <DialogContent>
                <UploadFile
                    values={files}
                    onChangeValues={(files) => setFiles(files)}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    disabled={haveNoFiles || isLoading}
                    onClick={handleConfirm}
                >
                    {
                        isLoading &&
                        <CircularProgress size={20} sx={{ marginRight: 1 }} />
                    }
                    Enviar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogEnviarArquivosProcessoProps {
    open: boolean,
    handleClose: () => void,
    codigo: string
}

//